import React, { useState, useEffect } from "react";
import { Select, Spin, notification } from "antd";
import conditionService from "../../services/conditions";

const { Option } = Select;

const ConditionSelect = ({ selectedForm, value, onChange, add_manage_wf, disabled }) => {
	const [conditions, setConditions] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getConditions = async () => {
			try {
				setLoading(true);
				const response = await conditionService.getConditions();
				setLoading(false);

				
				// let mergedConditionSCRF = "";
				// let mergedConditionCRF = "";
				// let mergedConditionSAPACCESS = "";
				// if (add_manage_wf) {
				// 	mergedConditionSCRF = [
				// 		// ...response[0]?.form.conditions,
				// 		...response[1]?.form?.conditions,
				// 	];
				// 	mergedConditionCRF = [
				// 		// ...response[0]?.form?.conditions,
				// 		...response[2]?.form?.conditions,
				// 	];
				// 	mergedConditionSAPACCESS = [...response[3]?.form?.conditions];
				// } else {
				// 	mergedConditionSCRF = [
				// 		...response[0]?.form?.conditions,
				// 		...response[1]?.form?.conditions,
				// 	];
				// 	mergedConditionCRF = [
				// 		...response[0]?.form?.conditions,
				// 		...response[2]?.form?.conditions,
				// 	];
				// 	mergedConditionSAPACCESS = [
				// 		...response[0]?.form?.conditions,
				// 		...response[3]?.form?.conditions,
				// 	];
				// }

				let mergedConditionSCRF = [];
				let mergedConditionCRF = [];
				let mergedConditionSAPACCESS = [];

				const c0 = response?.[0]?.form?.conditions || [];
				const c1 = response?.[1]?.form?.conditions || [];
				const c2 = response?.[2]?.form?.conditions || [];
				const c3 = response?.[3]?.form?.conditions || [];

				if (add_manage_wf) {
					mergedConditionSCRF = [...c1];
					mergedConditionCRF = [...c2];
					mergedConditionSAPACCESS = [...c3];
				} else {
					mergedConditionSCRF = [...c0, ...c1];
					mergedConditionCRF = [...c0, ...c2];
					mergedConditionSAPACCESS = [...c0, ...c3];
				}

				if (selectedForm === 2) {
					setConditions(mergedConditionSCRF);
				} else if (selectedForm === 4) {
					setConditions(mergedConditionCRF);
				} else if (selectedForm === 7) {
					setConditions(mergedConditionSAPACCESS);
				} else {
					if (add_manage_wf) {
						setConditions([]);
					} else {
						setConditions(response[0]?.form?.conditions);
					}
				}
			} catch (error) {
				setLoading(false);
				notification.error({
					message: "Error",
					description: error.response,
				});
			}
		};

		getConditions();
	}, [selectedForm]);

	return (
		<Spin spinning={loading}>
			<Select
				showSearch
				optionFilterProp='children'
				size='large'
				allowClear
				value={value}
				onChange={onChange}
				disabled={disabled}
			>
				{selectedForm != 0 && (
					<>
						{conditions.map((condition) => (
							<Option key={condition.id} value={condition.id}>
								{condition.name}
							</Option>
						))}
					</>
				)}
			</Select>
		</Spin>
	);
};

export default ConditionSelect;
